/**
 * The canonical interest lead quality vocabulary. This `as const` tuple is the single source of
 * truth so the zod mirror in `src/context/` can build `z.enum(...)` from it and cannot drift from
 * the pure engine types.
 */
export const INTEREST_LEAD_QUALITIES = ['cold', 'warm', 'hot', 'unqualified'] as const;
